import { useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Card, CardContent, Grid, GridColumn } from 'telia-front-react';
import InternetOfferCard from '../card/InternetOfferCard';
import { InternetAppropriateUses } from './InternetAppropriateUses';
import { InternetDescription } from './InternetDescription';
import { InternetDeviceInstallation } from './InternetDeviceInstallation';
import { PlannedInternetDescription } from './PlannedInternetDescription';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { SecureNetPerks } from './SecureNetPerks';
export const InternetDetails = (props) => {
    const { offer } = props;
    const { isSecureNet } = useInternetCalculator();
    const { isMobile } = useIsMobileHook();
    return (React.createElement(Grid, null,
        React.createElement(GridColumn, { width: offer.isEdit ? ['xs-12'] : ['xs-12', 'lg-9'] },
            React.createElement(Card, { padding: isMobile ? 'small' : 'medium' },
                React.createElement(CardContent, { background: "neutral-bg-level-2" },
                    React.createElement(Grid, null,
                        React.createElement(GridColumn, { width: ['xs-12', 'sm-5'] },
                            React.createElement(InternetOfferCard, { offer: offer, inModal: true })),
                        React.createElement(GridColumn, { width: ['xs-12', 'sm-7'] }, offer.properties.includes('PLANNED') ? (React.createElement(PlannedInternetDescription, { offer: offer })) : (React.createElement(React.Fragment, null,
                            React.createElement(InternetDescription, { offer: offer }),
                            isSecureNet && React.createElement(SecureNetPerks, { offer: offer }),
                            React.createElement(InternetAppropriateUses, { offer: offer })))))))),
        !offer.isEdit && (React.createElement(GridColumn, { width: ['xs-12', 'lg-3'] },
            React.createElement(InternetDeviceInstallation, { offer: offer })))));
};
